import React from 'react'
import { getBioDetail } from "data/Querys"
import { useQuery } from "@tanstack/react-query"
import Loader from 'components/general/Loader'
import NotAvailable from "components/common/NotAvailable";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import PersonInfo from "components/common/participants/PersonInfo"
import BioAnchors from "components/common/participants/BioAnchors"
import BioSchedule from 'components/common/participants/BioSchedule';
import PersonRecords from "components/common/participants/PersonRecords"
import BioMedals from "components/common/participants/BioMedals"
import BioData from "components/common/participants/BioData"
import { usePreparePayLoad } from 'components/common/ocs-custom-events/helpers';
import FireOnContentLoadOCS from 'components/general/FireOnContentLoadOCS';
import { useScrollToTop } from 'helpers/utils';

function BioDetail() {
    const params = useUrlFriendlyToParameters()
    let paramsURL = { ...params }
    const payloadParams = usePreparePayLoad()
    useScrollToTop();

    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['bioDetail', paramsURL['mirs_competition'], paramsURL['mirs_language'], paramsURL['mirs_code']],
            queryFn: getBioDetail,
            enabled: true,
            refetchInterval: 0,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            retry: false,
            suspense: false,
            // notifyOnChangeProps: [id] | "tracked"
        });

    if (isError) {
        return <NotAvailable label="LabelNoDataAvailable" />;
    }
    if (isLoading) {
        return <Loader />;
    }
    if (!data?.person) {
        return <NotAvailable label="LabelNoDataAvailable" />
    }

    return (
        <>
            <FireOnContentLoadOCS params={params} data={data} payloadParams={payloadParams} />
            <div className='mirs-page-container'>
                <div className="wrsBiosDetail__panel">
                    <div className="bios-personalinfo">
                        <section id="PersonInfo"><PersonInfo data={data} /></section>
                        <section id="BioAnchors"><BioAnchors data={data} /></section>
                    </div>
                    <section id="PersonRecords"><PersonRecords data={data} /></section>
                    <section id="BioMedals"><BioMedals data={data} /></section>
                    <section id="BioSchedule"><BioSchedule data={data} /></section>
                    <BioData data={data} />
                </div>
            </div>
        </>
    );
}

export default BioDetail


